export default "//yastatic.net/s3/distribution/pythia/frontend/_/229c4558c328593d648c89a9b8a1341e.png";